import { render, staticRenderFns } from "./institution.vue?vue&type=template&id=7a289bbc"
import script from "./institution.vue?vue&type=script&lang=js"
export * from "./institution.vue?vue&type=script&lang=js"
import style0 from "./institution.vue?vue&type=style&index=0&id=7a289bbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports